export default {"src":"/_next/static/media/music.9e177901.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};